/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <a href="#">
                        <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
                    </a>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">企業一覧</p>
                </div>
            </div>
        </div>
        <CommpanyBrandList/>
    </div>
</template>

<script>
    import CommpanyBrandList from '@/app/components/CommpanyBrandList.vue'
    export default {
        name: 'manageCommpanyBrandList',
        components: {
            CommpanyBrandList
        }
    }
</script>
